export const SET_MULTI_FEED_POSTS = 'SET_MULTI_FEED_POSTS'
export const SET_SELECTED_MULTI_FEED_POSTS_ID = 'SET_SELECTED_MULTI_FEED_POSTS_ID'
export const UPDATE_MULTI_FEED_POST = 'UPDATE_MULTI_FEED_POST'
export const UPDATE_MULTI_FEED_REPLY = 'UPDATE_MULTI_FEED_REPLY'
export const RESET_STATE = 'RESET_STATE'